import React from 'react';
import NumberFormatReact from 'react-number-format';

const NumberFormat = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <NumberFormatReact
      displayType='text'
      thousandSeparator={true}
      renderText={(value) => <span {...props}>{value}</span>}
      {...props}
    />
  );
};

export default React.memo(NumberFormat);
